// extracted by mini-css-extract-plugin
export default {"section5":"section5_section5__gbDbT","image":"section5_image__lRJsQ"};